import {
  GET_THEMES_LIST_SUCCESS,
  GET_THEMES_LIST_ERROR,
  CLEAR_GET_THEMES_LIST,
  PATCH_CUSTOM_THEME_SUCCESS,
  PATCH_CUSTOM_THEME_ERROR,
  CLEAR_PATCH_CUSTOM_THEME,
  REPLICATE_EXISTING_THEME_SUCCESS,
  REPLICATE_EXISTING_THEME_ERROR,
  CLEAR_REPLICATE_EXISTING_THEME,
} from 'redux/themes/types';

const initialState = {
  themesList: null,
  themesListError: null,
  patchCustomThemeSuccess: null,
  patchCustomThemeError: null,
  replicateExistingThemeSuccess: null,
  replicateExistingThemeError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case GET_THEMES_LIST_SUCCESS:
      return {
        ...state,
        themesList: action.payload.data,
        themesListError: null,
      };
    case GET_THEMES_LIST_ERROR:
      return {
        ...state,
        themesList: null,
        themesListError: action.payload.data,
      };
    case CLEAR_GET_THEMES_LIST:
      return {
        ...state,
        themesList: null,
        themesListError: null,
      };
    case PATCH_CUSTOM_THEME_SUCCESS:
      return {
        ...state,
        patchCustomThemeSuccess: action.payload.data,
        patchCustomThemeError: null,
      };
    case PATCH_CUSTOM_THEME_ERROR:
      return {
        ...state,
        patchCustomThemeSuccess: null,
        patchCustomThemeError: action.payload.data,
      };
    case CLEAR_PATCH_CUSTOM_THEME:
      return {
        ...state,
        patchCustomThemeSuccess: null,
        patchCustomThemeError: null,
      };
    case REPLICATE_EXISTING_THEME_SUCCESS:
      return {
        ...state,
        replicateExistingThemeSuccess: action.payload.data,
        replicateExistingThemeError: null,
      };
    case REPLICATE_EXISTING_THEME_ERROR:
      return {
        ...state,
        replicateExistingThemeSuccess: null,
        replicateExistingThemeError: action.payload.data,
      };
    case CLEAR_REPLICATE_EXISTING_THEME:
      return {
        ...state,
        replicateExistingThemeSuccess: null,
        replicateExistingThemeError: null,
      };
    default:
      return state;
  }
};
